/*
Ashraf 01/11/2023 2699710829 initial tab render for audit list

*/
import React from 'react';
import GLobalFieldList from '../GlobalFieldList';

const AuditFieldList = ({tabValue, setTabValue, StepperFieldList}) => {
  return (
    <>
      <GLobalFieldList StepperFieldList={StepperFieldList} />
    </>
  );
};

export default AuditFieldList;
